import React from "react";
import Charts from "../components/Charts/Charts";
import { calculateCompoundInterest } from "../api";
import { GlobalContext } from "../context/GlobalContext";
import SEO from "../components/SEO/SEO";
import formatNumber from "../helpers/formatNumber";
import ToolDisclaimer from "../components/Disclaimer/ToolDisclaimer";

function CompoundInterest() {
  const { isMobile } = React.useContext(GlobalContext);
  const [calculatedCompoundInterest, setCalculatedCompoundInterest] =
    React.useState({});
  const [compoundInterestChartData, setCompoundInterestChartData] =
    React.useState([]);
  const selectedChartData = ["Eingezahlt", "Zinsen"];

  //* handle form submit function
  const handleSubmit = async (e) => {
    e.preventDefault();

    const capital = e.target[0]?.value;
    const saving = e.target[1]?.value;
    const interest = e.target[2]?.value;
    const duration = e.target[3]?.value;
    const interval = e.target[4]?.value;

    try {
      const result = await calculateCompoundInterest(
        capital,
        saving,
        interest,
        duration,
        interval
      );
      //* set result to state
      setCalculatedCompoundInterest(result.result);

      //* convert object of object to array of object
      const arrayOfObjects = Object.entries(result.result.details).map(
        ([key, value]) => {
          return { id: key, ...value };
        }
      );

      //* set chart Data
      const chartData = [];
      arrayOfObjects.forEach((el, index) => {
        chartData.push({
          name: `Jahr ${index + 1}`,
          Eingezahlt: el?.paidIn,
          Zinsen: el?.interestIncome,
        });
      });
      setCompoundInterestChartData(chartData);
    } catch (error) {}
  };

  return (
    <>
      <SEO
        title="Zinseszinsrechner"
        keywords="Zinseszinsrechner"
        description="Zinseszinsrechner"
        type="Zinseszinsrechner"
        url={window.location.href}
      />
      <div
        className={`${!isMobile && "article-text"} ${
          isMobile && "add-padding-20"
        } text-justify text-light`}
      >
        <h1 className="text-light article-header">Zinseszinsrechner</h1>
        <ToolDisclaimer />

        <br />
        <form onSubmit={handleSubmit} id="compoundInterestForm">
          <div className="form-group">
            <label className="text-light" for="formName">
              Anfangskapital
            </label>
            <div className="input-group">
              <input
                type="number"
                className="form-control"
                id="formName"
                required
                step="any"
                defaultValue={5000}
                min={0}
              />
              <span className="input-group-text" id="basic-addon2">
                €
              </span>
            </div>
          </div>

          <div className="form-group">
            <label className="text-light" for="formName">
              Monatliche Sparrate
            </label>
            <div className="input-group">
              <input
                type="number"
                className="form-control"
                id="formName"
                required
                step="any"
                defaultValue={100}
                min={0}
              />
              <span className="input-group-text" id="basic-addon2">
                €
              </span>
            </div>
          </div>

          <div className="form-group">
            <label className="text-light" for="formName">
              Jährlicher Zinssatz
            </label>
            <div className="input-group">
              <input
                type="number"
                className="form-control"
                id="formName"
                required
                step="any"
                defaultValue={3}
              />
              <span className="input-group-text" id="basic-addon2">
                %
              </span>
            </div>
          </div>

          <div className="form-group">
            <label className="text-light" for="formName">
              Anlagezeitraum
            </label>
            <div className="input-group">
              <input
                type="number"
                className="form-control"
                id="formName"
                required
                defaultValue={10}
                min={1}
              />
            </div>
          </div>

          <div className="form-group">
            <label for="inputState">Ausschüttungsintervall</label>
            <select id="inputState" className="form-control">
              <option value="M" selected>
                monatlich
              </option>
              <option value="Q">quartalsweise</option>
              <option value="Y">jährlich</option>
            </select>
          </div>
          <div className="text-right">
            <button type="submit" className="btn btn-primary formsubmit">
              Berechnen
            </button>
          </div>
        </form>
        {calculatedCompoundInterest &&
          Object.keys(calculatedCompoundInterest)?.length > 0 && (
            <>
              <br />
              <p>
                Wenn du monatlich
                <b className="visualizeLink linkIsInformative">
                  {` ${formatNumber(
                    calculatedCompoundInterest?.savingRate?.toFixed(2)
                  )}€ `}
                </b>
                mit einem Anfangskapital von
                <b className="visualizeLink linkIsInformative">{` ${formatNumber(
                  calculatedCompoundInterest?.startcapital?.toFixed(2)
                )}€ `}</b>
                zu
                <b className="visualizeLink linkIsInformative">{` ${formatNumber(
                  calculatedCompoundInterest?.interestRate?.toFixed(2)
                )}% `}</b>
                für die nächsten
                <b className="visualizeLink linkIsInformative">{` ${formatNumber(
                  calculatedCompoundInterest?.duration?.toFixed(2)
                )}
                Jahre `}</b>
                investierst, erhälst du bis zum Ende deines Anlagezeitraums
                Zinsen in Höhe von
                <b className="visualizeLink linkIsInformative">{` ${formatNumber(
                  calculatedCompoundInterest?.interestIncome?.toFixed(2)
                )}€`}</b>
                . Somit ergibt sich nun ein Gesamtkapital von
                <b className="visualizeLink linkIsInformative">{` ${formatNumber(
                  calculatedCompoundInterest?.final?.toFixed(2)
                )}€.`}</b>
              </p>

              <br />

              <Charts.StackedBar
                data={compoundInterestChartData}
                titleX="name"
                colors={[
                  { key: "Eingezahlt", color: "#a938d3" },
                  { key: "Zinsen", color: "#00ffcc" },
                ]}
                showTooltip
                tooltipValues={selectedChartData}
                tooltipFooter={{ title: "Summe", values: selectedChartData }}
              />
            </>
          )}
      </div>
    </>
  );
}

export default CompoundInterest;
